"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledButton = _interopRequireDefault(require("./styled-button"));
var _excluded = ["href"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var forwardRef = _react["default"].forwardRef;
var sizes = ['large', 'medium', 'small'];
var propTypes = {
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  dataTestId: _propTypes["default"].string,
  icon: _propTypes["default"].element,
  iconRight: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  href: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(sizes), _propTypes["default"].shape(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(function (acc, current) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, current, _propTypes["default"].oneOf(sizes)));
  }, {}))]),
  variant: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary'])
};
var defaultProps = {
  children: null,
  dataTestId: null,
  disabled: false,
  fullWidth: false,
  href: undefined,
  icon: undefined,
  iconRight: false,
  size: 'large',
  variant: 'primary'
};
var Button = forwardRef(function (_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var href = props.href,
    otherProps = _objectWithoutProperties(props, _excluded);
  var dataTestId = otherProps.dataTestId,
    disabled = otherProps.disabled;
  if (href && href.length > 0 && disabled === false) {
    return /*#__PURE__*/_react["default"].createElement(_styledButton["default"], _extends({
      className: "fuse-button",
      "data-testid": dataTestId
    }, props, {
      as: "a",
      ref: ref
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_styledButton["default"], _extends({
    className: "fuse-button",
    "data-testid": dataTestId,
    ref: ref
  }, otherProps));
});
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
var _default = exports["default"] = Button;